import { baseUrl } from './util';
import request from '@/utils/request';

export interface SnCheckParams {
    sn: string;
    campaignId: number;
    snUrl: string;
    deviceUrl: string;
}

export interface SubmitExchangeParams {
    recaptchaResponse: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    address: string;
    country?: string;
    state: string;
    city: string;
    zipCode: string;
    sn: string;
    agreed: boolean;
    snUrl: string;
    deviceUrl: string;
    campaignId: number;
}

export interface MyMysteryBoxListParams {
    page?: number;
    size?: number;
    userId?: number;
    campaignId?: number;
}

/**
 * 查询当前站点换新活动
 */
export const queryCampaign = (locale: string, params?: { campaignId?: number; name?: string }): any =>
    request.get(`${baseUrl(locale)}/exchangeCampaign/query`, { params });

/**
 * SN 码校验
 */
export const checkSn = (data: SnCheckParams, locale: string): any => request.post(`${baseUrl(locale)}/exchangeCampaign/snCheck`, { data, needToken: true });

/**
 * 换新活动提交（含设备回收地址）
 */
export const submitExchange = (data: SubmitExchangeParams, locale: string): any =>
    request.post(`${baseUrl(locale)}/exchangeCampaign/submit`, { data, needToken: true });

/**
 * 我的盲盒列表（分页）
 */
export const getMyMysteryBoxList = (params: MyMysteryBoxListParams, locale: string): any =>
    request.post(`${baseUrl(locale)}/exchangeCampaign/getPageByUserId`, {
        params: params,
        needToken: true,
    });
